import { render, staticRenderFns } from "./held.vue?vue&type=template&id=2dbf0cc4"
import script from "./held.vue?vue&type=script&lang=js"
export * from "./held.vue?vue&type=script&lang=js"
import style0 from "./held.vue?vue&type=style&index=0&id=2dbf0cc4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports